import { format, parseISO } from 'date-fns';
import ptBrLocale from 'date-fns/locale/pt-BR';
import Vue from 'vue';

const DEFAULT_LOCALE_DATE_FORMAT = 'dd/MM/yyyy - HH:mm';
const DEFAULT_LOCALE_DATE_FORMAT_WITH_COMMA = 'dd/MM/yyyy, HH:mm';
const DEFAULT_LOCALE_DATE_FORMAT_WITHOUT_HOUR = 'dd/MM/yyyy';
const DEFAULT_LOCALE_DATE_FORMAT_WITHOUT_HOUR_SHORTENED_YEAR = 'dd/MM/yy';
const DEFAULT_LOCALE_FULL_DATE_FORMAT = "dd 'de' MMMM 'de' yyyy 'às' HH:mm";
const DEFAULT_LOCALE_FULL_DATE_SHORT_MONTH_FORMAT = "dd 'de' MMM 'de' yyyy 'às' HH:mm";
const DEFAULT_LOCALE_FULL_DATE_FORMAT_WITHOUT_HOUR = "dd 'de' MMMM 'de' yyyy";
const DEFAULT_LOCALE_HOUR_FORMAT = 'HH:mm';
const DEFAULT_LOCALE_DATE_FORMAT_WITH_HOUR_SHORTENED_YEAR='dd/MM/yy - HH:mm';

const formatDate = (date, defaultFormat, locale = null) => {
  if (!date) {
    return '';
  }

  let parsedDate;

  if (typeof date === 'string' || date instanceof String) {
    parsedDate = parseISO(date);
  }

  return format(parsedDate, defaultFormat, { locale });
};

Vue.filter('formatDate', (date) => {
  return formatDate(date, DEFAULT_LOCALE_DATE_FORMAT);
});

Vue.filter('formatDateWithComma', (date) => {
  return formatDate(date, DEFAULT_LOCALE_DATE_FORMAT_WITH_COMMA);
});

Vue.filter('formatDateWithoutHour', (date) => {
  return formatDate(date, DEFAULT_LOCALE_DATE_FORMAT_WITHOUT_HOUR);
});

Vue.filter('formatDateWithoutHourAndShortenedYear', (date) => {
  return formatDate(date, DEFAULT_LOCALE_DATE_FORMAT_WITHOUT_HOUR_SHORTENED_YEAR);
});

Vue.filter('formatFullDate', (date) => {
  return formatDate(date, DEFAULT_LOCALE_FULL_DATE_FORMAT, ptBrLocale);
});

Vue.filter('formatFullDateShortMonth', (date) => {
  return formatDate(date, DEFAULT_LOCALE_FULL_DATE_SHORT_MONTH_FORMAT, ptBrLocale);
});

Vue.filter('formatFullDateWithoutHour', (date) => {
  return formatDate(date, DEFAULT_LOCALE_FULL_DATE_FORMAT_WITHOUT_HOUR, ptBrLocale);
});

Vue.filter('formatHour', (date) => {
  return formatDate(date, DEFAULT_LOCALE_HOUR_FORMAT);
});

Vue.filter('formatDateWithHourShortenedYear', (date) => {
  return formatDate(date, DEFAULT_LOCALE_DATE_FORMAT_WITH_HOUR_SHORTENED_YEAR);
});

Vue.filter('formatToUTCHour', (date) => {
  const time = new Date(date);
  if (!time.getTime()) {
    return '';
  }

  const hours = time.getUTCHours().toString().padStart(2, '0');
  const minutes = time.getUTCMinutes().toString().padStart(2, '0');
  const seconds = time.getUTCSeconds().toString().padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
});

Vue.filter('formatDateCustom', ({ date, format = 'yyyy-MM-dd' }) => {
  return formatDate(date, format);
});

Vue.filter('formatDateResumedHours', (date) => {
  const workingDate = new Date(date);
  if (!workingDate.getTime()) {
    return '';
  }
  const format =  workingDate.getMinutes() === 0
    ? "dd/MM/yyyy - H'h'"
    : "dd/MM/yyyy - H'h'mm";

  return formatDate(date, format);
});
